import { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Navigation } from "swiper/modules";
import "../styles/sections.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchSectionData } from "../features/events/events_slice";

function InternationalSection({ section }) {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const eventsData = useSelector((state) =>
    section === "himalayan"
      ? state.events.himalayanSectionData
      : state.events.intSectionData
  );
  const loading = useSelector((state) => state.events.loading);

  useEffect(() => {
    if (loading) {
      dispatch(fetchSectionData(section));
    }
  }, [section, dispatch, loading]);

  if (loading) return <></>;
  if (eventsData.length === 0) return <></>;

  return (
    <div className="section-carousel">
      <Swiper
        key={section}
        className="section-swiper"
        pagination={{ clickable: true }}
        modules={[Pagination, Navigation]}
        navigation
        spaceBetween={8}
        loop={true}
        // slidesPerView={4}
        breakpoints={{
          750: { slidesPerView: 5 },
          0: { slidesPerView: 1.5 },
        }}
      >
        {eventsData.map((item) => (
          <SwiperSlide key={item.created_date}>
            <div
              onClick={() => {
                sessionStorage.setItem("categoryScroll", window.scrollY);
                return navigate(
                  `/${item.event_type}/${item.id}/${item.title.replace(
                    / /g,
                    "-"
                  )}`,
                  {
                    state: { passedData: item },
                  }
                );
              }}
              className="section-image-container"
            >
              <img
                src={item.main_image}
                alt={`Slide ${item.created_date}`}
                className="section-image"
              />
              <div className="gradient-overlay"></div>
              <div className="section-text-container">
                <p className="section-text-title">{item.title}</p>
                <div className="section-price-container">
                  <span className="section-price">
                    {Number(item.price) === 0
                      ? "Contact for Pricing"
                      : "₹ " + Number(item.price).toLocaleString()}
                  </span>
                  <span className="section-price">{item.duration}</span>
                  {/* <span className="section-price">{item.event_type}</span> */}
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default InternationalSection;
